import {
  SET_LIVE_AVAILABLE_LANGUAGES,
  PLAYER_LIVE_HIDE_LANGUAGE_OPTIONS,
  PLAYER_LIVE_SHOW_LANGUAGE_OPTIONS,
  SET_LIVE_AVAILABLE_CAPTIONS,
} from '../../actions/optionButtons/constants';

const initialState = {
  isOpen: false,
  availableLanguages: null,
  availableCaptions: null,
  currentAudioLanguage: null,
  targetAudioLanguage: null,
  showChevron: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LIVE_AVAILABLE_LANGUAGES:
      return { ...state, availableLanguages: action.availableLanguages };
    case SET_LIVE_AVAILABLE_CAPTIONS:
      return { ...state, availableCaptions: action.availableCaptions };
    case PLAYER_LIVE_SHOW_LANGUAGE_OPTIONS:
      return { ...state, showChevron: action.showChevron, isOpen: true };
    case PLAYER_LIVE_HIDE_LANGUAGE_OPTIONS:
      return { ...state, showChevron: false, isOpen: false };
    case 'SET_LIVE_CURRENT_AUDIO_LANGUAGE':
      return { ...state, currentAudioLanguage: action.currentAudioLanguage };
    case 'SET_VOD_TARGET_LANGUAGE':
      return { ...state, targetAudioLanguage: action.targetAudioLanguage };
    case 'CLEAR_AUDIO_LANGUAGE':
      return {...state, targetAudioLanguage: null, currentAudioLanguage: null}
    default:
      return state;
  }
};
